var _mask, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinusRing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "MinusRing_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 20v-1a9 9 0 0 1-9-9h-2c0 6.075 4.925 11 11 11zm10-10h-1a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zM10 0v1a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm0 0v-1C3.925-1-1 3.925-1 10h2a9 9 0 0 1 9-9z",
  mask: "url(#MinusRing_svg__a)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#MinusRing_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.999,
  d: "M6.01 10.005H14"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "MinusRing_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.57 5.57h8.86v8.86H5.57z"
})))));
export default SvgMinusRing;